import React from 'react'
import { observer } from 'mobx-react-lite'
import {
  Card,
  CardHeader,
  CardTitle,
  CardTitleCount,
  CardContent,
} from 'components/Card'
import JobViewModel from '../JobViewModel'
import styles from './InfoLinesCard.sass'

interface InfoLineItemProps {
  title: string
  children: React.ReactNode
}

const InfoLine = ({ title, children }: InfoLineItemProps) => {
  return (
    <div className={styles.infoLinesItem}>
      <div className={styles.infoLinesItemLabel}>{title}</div>
      <div className={styles.infoLinesItemValue}>{children}</div>
    </div>
  )
}

interface Props {
  vm: JobViewModel
}

export default observer(function ({ vm }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Info lines
          <CardTitleCount>({vm.job.infoLines.length})</CardTitleCount>
        </CardTitle>
      </CardHeader>
      <CardContent scroll>
        {vm.job.infoLines.map((line, i) => (
          <InfoLine key={i} title={line.title}>
            {line.content}
          </InfoLine>
        ))}
      </CardContent>
    </Card>
  )
})
